var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.programa)?_c('AppPrograma',{attrs:{"programa":_vm.programa,"becario":_vm.becario}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }